@if (onTrial()) {
    <div class="bg-light border border-1 border-primary p-3 rounded-2 small">
        <div>
            <p class="mb-1 fw-bold">Surefire Trial</p>
            <p class="mb-0">
                {{ trialDaysLeft() }} days left on your trial. Please ensure your payment details are up to date to
                avoid any disruption to your service.
            </p>
        </div>
        <div *ngxPermissionsOnly="'ADMIN'">
            <a
                sfButton
                class="mt-2"
                icon="cog"
                color="primary"
                size="sm"
                variant="outline"
                routerLink="/admin/subscription/payment-details"
                >Manage</a
            >
        </div>
    </div>
}
